import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

const GET_NOTES = `
	notes(
		page: $page,
		limit: $limit,
		color: $color,
		keyword: $keyword,
		orderBy: $orderBy
	) {
		...NotePagination
	}
`;

const ADD_NOTE = `
	create_note (title: $title, content: $content, color: $color, files: $files) {
		...Note
	}
`;

const UPDATE_NOTE = `
	update_note (id: $id, title: $title, content: $content,color: $color, files: $files) {
		...Note
	}
`;

const DELETE_NOTE = `
	delete_note (id: $id) {
		...Note
	}
`;

const SORT_NOTES = `
	sort_notes(
		ids: $ids,
		color: $color,
		keyword: $keyword
	)
`;

export default {
	init() {},

	getNotes(payload) {
		return graphqlClient
			.query({
				query: gql`query Notes ($limit: Int!, $page: Int!, $color: String, $keyword: String, $orderBy: OrderByObject) {
					${GET_NOTES}
				}
				${fragments.File}
				${fragments.Note}
				${fragments.Document}
				${fragments.BackendUser}
				${fragments.NotePagination}
			`,
				variables: {
					page: payload.page || 1,
					limit: payload.limit || 5,
					color: payload.color || "",
					keyword: payload.keyword || "",
					orderBy: payload.orderBy || null,
				}
			})
			.then(response => response.data.notes);
	},

	addNote(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddNote ($title: String, $content: String, $color: String, $files:[Int]) {
					${ADD_NOTE}
				}
				${fragments.File}
				${fragments.Note}
				${fragments.Document}
				${fragments.BackendUser}
			`,
				variables: {
					title: payload.title,
					color: payload.color,
					content: payload.content,
					files: payload.files,
				}
			})
			.then(response => response.data.create_note);
	},

	updateNote(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateNote ($id: Int!, $title: String, $content: String, $color: String, $files:[Int]) {
					${UPDATE_NOTE}
				}
				${fragments.File}
				${fragments.Note}
				${fragments.Document}
				${fragments.BackendUser}
			`,
				variables: {
					id: payload.id,
					title: payload.title,
					color: payload.color,
					content: payload.content,
					files: payload.files,
				}
			})
			.then(response => response.data.update_note);
	},

	deleteNote(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteNote ($id: Int!) {
					${DELETE_NOTE}
				}
				${fragments.File}
				${fragments.Note}
				${fragments.Document}
				${fragments.BackendUser}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.delete_note);
	},

	sortNotes(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SortNotes ($ids: [Int!], $color: String, $keyword: String) {
					${SORT_NOTES}
				}
			`,
				variables: {
					ids: payload.ids,
					color: payload.color || "",
					keyword: payload.keyword || ""
				}
			})
			.then(response => response.data.sort_notes);
	},
};
